const { PaymentMethod } = require('@shared/collections/user.collection')

/**
 * @param {import('@shared/collections/user.collection').UserModel} user
 * @returns {boolean}
 */
const isSubscriptionActive = (user) => {
  if (
    user.paymentMethod == PaymentMethod.CREDIT_CARD &&
    user.stripeSubscriptionId &&
    user.stripeSubscriptionStatus == 'active'
  ) {
    // OK
    return true
  }

  if (user.paymentMethod == PaymentMethod.BANK_TRANSFER && user.plan && user.bankTransferStatus == 'active') {
    // OK
    return true
  }

  return false
}

module.exports = {
  isSubscriptionActive
}
